import React from "react";

const CodeIcon = ({ stroke = "#2D2C44", size = "24", strokeOpacity = "0.7" }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M16 18L22 12L16 6M8 6L2 12L8 18" stroke={stroke} strokeOpacity={strokeOpacity} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
  </svg>
);

export default CodeIcon;
